import { useForm } from 'react-hook-form';
import styles from './termsAndConditions.module.scss';
import { RegistrationFormData } from '@/components/modals/RegistrationModal/RegistrationModal';
import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '@goodneighbor/ui';
import text from './text';

export default function TermsAndConditions({
  form
}: {
  form: ReturnType<typeof useForm<RegistrationFormData>>;
}) {
  return (
    <div className={styles.termsAndConditions}>
      <div className={styles.card}>
        <h2 className={styles.title}>
          Release of Liability & Standards of Conduct
        </h2>
        <div className={styles.description}>{text}</div>
      </div>
      <FormField
        control={form.control}
        name="acceptedTermsAndConditionsAt"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Checkbox
                isSelected={!!field.value}
                onChange={(value) => {
                  field.onChange(value ? new Date().toISOString() : '');
                  form.clearErrors('acceptedTermsAndConditionsAt');
                }}
                id="acceptedTermsAndConditionsAt"
                label="I hereby acknowledge that I have read, understand and will abide by each of the terms and conditions of this agreement."
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
